import type { TreeTableFilterMeta, TreeTableSortMeta } from 'primevue'
import type { DataTablePageEvent, DataTableSortMeta } from 'primevue/datatable'
import type { DataViewPageEvent } from 'primevue/dataview'
import * as yup from 'yup'

export const getFiltersValue = (filters?: TreeTableFilterMeta) => {
  if (filters === undefined) return {}

  const newFilters: Record<
    string,
    Date | Date[] | string | string[] | undefined
  > = {}

  Object.keys(filters).forEach((key: string) => {
    const filter = filters[key]

    if (typeof filter === 'string') return
    if (!filter || !('value' in filter)) return

    let value = filter.value

    if (value && Object.hasOwn(value, 'id')) value = value.id

    newFilters[key] = value
  })

  return newFilters
}

export const getSortValue = (sort: DataTableSortMeta | TreeTableSortMeta) => {
  if (sort.order === 1) return { o: sort.field }
  if (sort.order === -1) return { o: `-${sort.field}` }

  return {}
}

export const getPagination = (
  event: DataTablePageEvent | DataViewPageEvent
) => {
  return {
    page: event.page + 1,
    per_page: event.rows,
  }
}

export type ListState = {
  filters: TreeTableFilterMeta
  pagination: {
    page: number
    per_page: number
  }
  sort: TreeTableSortMeta
  expandedRows?: Record<string, boolean>
}

export type FormField = {
  as: string
  name: string
  label?: string
  listeners?: Record<string, any>
  schema: yup.Schema
  [key: string]: any
}

export type FormSubmitProps = {
  label?: string
  icon?: string
  severity?: string
}
